import { render, staticRenderFns } from "./MessageBlock.vue?vue&type=template&id=a6b91b98&scoped=true&"
import script from "./MessageBlock.vue?vue&type=script&lang=js&"
export * from "./MessageBlock.vue?vue&type=script&lang=js&"
import style0 from "./MessageBlock.vue?vue&type=style&index=0&id=a6b91b98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b91b98",
  null
  
)

export default component.exports